import { render, staticRenderFns } from "./TsysAch.vue?vue&type=template&id=317718de&scoped=true&"
import script from "./TsysAch.vue?vue&type=script&lang=js&"
export * from "./TsysAch.vue?vue&type=script&lang=js&"
import style0 from "./TsysAch.vue?vue&type=style&index=0&id=317718de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317718de",
  null
  
)

export default component.exports